import { Connection } from "@afar-research/client-runtime/connection";
import { BrowserCrypto } from "@effect/platform-browser";
import * as Layer from "effect/Layer";
import { Atom } from "effect/unstable/reactivity";

import { runtimeContextLayer } from "../lib/runtime";
import { connectionPlatformLayer } from "./platform";
import { gitHubRoutingPermissionsLayer } from "./githubRouting";
import { clientTransportResourcesLayer } from "./resources";

const providedConnectionPlatformLayer = connectionPlatformLayer.pipe(
  Layer.provide(Layer.merge(runtimeContextLayer, clientTransportResourcesLayer)),
);

type ConnectionLayerSource =
  | typeof Connection.layer
  | typeof runtimeContextLayer
  | typeof connectionPlatformLayer
  | typeof clientTransportResourcesLayer
  | typeof gitHubRoutingPermissionsLayer
  | typeof BrowserCrypto.layer;

const connectionLayer = Connection.layer.pipe(
  Layer.provideMerge(
    Layer.mergeAll(
      runtimeContextLayer,
      providedConnectionPlatformLayer,
      BrowserCrypto.layer,
      clientTransportResourcesLayer,
      gitHubRoutingPermissionsLayer,
    ),
  ),
);

export const connectionAtomRuntime: Atom.AtomRuntime<
  Layer.Success<ConnectionLayerSource>,
  Layer.Error<ConnectionLayerSource>
> = Atom.runtime(connectionLayer);
